const B_1 = [
    {
        title: '标段管理',
        path: '/bidding/projectflow/fangan/biaoduan/list'
    }
]
export default {
    path: 'biaoduan',
    component: () => import(/*webpackChunkName: 'bidding-biaoduan'*/ '@layout/empty'),
    children: [
        {
            path:"list",
            component: () => import(/*webpackChunkName: 'bidding-biaoduan'*/ '@views/bidding/views/project-flow/fang-an/biaoduan/list'),
            meta: {
                title: '标段管理',
                bread: B_1
            },
        },{
            path:"form",
            component: () => import(/*webpackChunkName: 'bidding-biaoduan'*/ '@views/bidding/views/project-flow/fang-an/biaoduan/form'),
            meta: {
                title: '创建标段',
                bread: [
                    ...B_1,
                    {
                        title: '创建标段',
                        path: '/bidding/projectflow/fangan/biaoduan/form'
                    },
                ]
            },
        },{
            path:"detail",
            component: () => import(/*webpackChunkName: 'bidding-biaoduan'*/ '@views/bidding/views/project-flow/fang-an/biaoduan/detail'),
            meta: {
                title: '标段详情',
                bread: [
                    ...B_1,
                    {
                        title: '标段详情',
                        path: '/bidding/projectflow/fangan/biaoduan/detail'
                    },
                ]
            },
        },{
            path:"extEdit",
            component: () => import(/*webpackChunkName: 'bidding-biaoduan'*/ '@views/bidding/views/project-flow/fang-an/biaoduan/extEdit'),
            meta: {
                title: '完善场地信息',
                bread: [
                    ...B_1,
                    {
                        title: '标段详情',
                        path: '/bidding/projectflow/fangan/biaoduan/extEdit'
                    },
                ]
            },
        }
    ]
}